import type { ThemeOptions } from '@mui/material';

import { black, gray } from '~/styles/colors';

const BreadcrumbsTheme: ThemeOptions['components'] = {
  MuiBreadcrumbs: {
    styleOverrides: {
      separator: {
        color: gray[400],
      },
      li: {
        color: black[600],
        '& .MuiLink-root': {
          color: gray[900],
        },
      },
    },
  },
};

export default BreadcrumbsTheme;
